import React, { useState, useEffect } from 'react';

function SessionManager({ onResumeSession, type }) {
  const [savedSessions, setSavedSessions] = useState([]);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    loadSessions();
  }, [type]);

  const loadSessions = () => {
    const sessions = Object.keys(localStorage)
      .filter(key => key.startsWith(`reconciliation_${type}_`))
      .map(key => {
        const session = JSON.parse(localStorage.getItem(key));
        return {
          key,
          date: new Date(parseInt(key.split('_')[2])),
          progress: `${session.currentIndex + 1}/${session.ids.length}`,
        };
      })
      .sort((a, b) => b.date - a.date);
    setSavedSessions(sessions);
  };

  const formatDate = (date) => {
    return date.toLocaleString();
  };

  const handleDeleteSession = (key) => {
    localStorage.removeItem(key);
    loadSessions(); // Reload the sessions after deletion
  };

  const handleResumeSession = (sessionKey) => {
    const sessionData = JSON.parse(localStorage.getItem(sessionKey));
    onResumeSession(sessionData, sessionKey);
  };

  return (
    <div className="mb-4">
      <h3 className="text-xl font-bold mb-2">Resume Saved Session</h3>
      {savedSessions.length > 0 ? (
        <ul className="space-y-2">
          {savedSessions.map((session) => (
            <li key={session.key} className="border p-2 rounded flex justify-between items-center">
              <span>{formatDate(session.date)} - Progress: {session.progress}</span>
              <div>
                <button
                  onClick={() => handleResumeSession(session.key)}
                  className="bg-green-500 hover:bg-green-700 text-white font-bold py-1 px-2 rounded mr-2"
                >
                  Resume
                </button>
                <button
                  onClick={() => handleDeleteSession(session.key)}
                  className="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 rounded"
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p>No saved sessions found.</p>
      )}
    </div>
  );
}

export default SessionManager;